// Planes de crédito por nivel para «Teléfonos». Misma llave que Políticas: comparten caché.
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { listCreditPlans } from '@/api/services/loan-offerings/loan-offerings.client';
import { toLevelPlans, type LevelPlan } from '../lib/levelPlans';

export const LEVEL_PLANS_KEY = ['loan-offerings', 'credit-plans'] as const;

export interface LevelPlansState {
    /** `null` mientras carga o si no se pudieron leer (p. ej. 403 sin `loan.creditPlan.read`). */
    plans: LevelPlan[] | null;
    isLoading: boolean;
    isError: boolean;
}

export function useLevelPlans(): LevelPlansState {
    const query = useQuery({
        queryKey: LEVEL_PLANS_KEY,
        queryFn: listCreditPlans,
        staleTime: 5 * 60_000,
        retry: false,
    });
    const plans = useMemo(() => (query.data ? toLevelPlans(query.data) : null), [query.data]);
    return { plans, isLoading: query.isLoading, isError: query.isError };
}
